import React from 'react';
import ContentContainer from '../../components/LayoutComponents/ContentContainer';
import StatementComponent from '../../components/CbsComponents/Statement/StatementPdfComponent';

const StatementPage: React.FC = () => {
  const breadcrumbs = [
    {
      title: 'menu.loans',
      href: '/loans',
    },
    {
      title: 'menu.statementPdf',
      href: `/statement`,
    },
  ];
  return (
    <ContentContainer
      helmetTitle="statement.helmet-title"
      pageTitle="statement.page-title"
      breadcrumbs={breadcrumbs}
    >
      <StatementComponent />
    </ContentContainer>
  );
};
export default StatementPage;
